import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import billReducer from "./billSlice";
import themeReducer from "./themeSlice";
import edgeReducer from "./edgeSlice";
import { setWorkingHours } from "../lib/workingHours";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    bills: billReducer,
    theme: themeReducer,
    // Локалният резерв (режим облак/каса) — docs/edge.md
    edge: edgeReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Работното време за чистата логика на справките и резервациите — виж
// `lib/workingHours.ts`. Веднъж за началното състояние (самоличността може да
// е хидратирана от кеша) и после при всяка промяна.
const syncWorkingHours = () =>
  setWorkingHours(store.getState().auth.user?.configuration?.workingHours);
syncWorkingHours();
store.subscribe(syncWorkingHours);
